(function (window) {
    "use strict";

    DSV.template.bannerTemplate = {
        getTemplate: (banner) => (`
        <div class="search-result__banner">
            <p>${banner.BannerText}</p>
        </div>
        `)
    };
})(window);